module.exports = {"211402001":"连山街道","211402002":"站前街道","211402003":"渤海街道","211402004":"兴工街道","211402005":"石油街道","211402006":"化工街道","211402007":"化机街道","211402008":"水泥街道","211402011":"锦郊街道","211402104":"钢屯镇","211402105":"寺儿堡镇","211402106":"新台门镇","211402201":"沙河营乡","211402202":"孤竹营子乡","211402203":"白马石乡","211402205":"山神庙子乡","211402206":"塔山乡","211402210":"杨郊乡","211402400":"杨家杖子经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211402.json
// module id = 597
// module chunks = 0